var currentlySelected = null;

// Function to reset everything to default state
function resetToDefault() {
    document.querySelectorAll(".hover-element, .landmark-selection, .sidebar-container").forEach(el => {
        if (el) el.style.display = "none";
    });
    document.querySelectorAll(".landmark").forEach(el => {
        if (el) el.style.display = "block";
    });
    const sidebar = document.querySelector(".sidebar");
    if (sidebar) sidebar.classList.remove("active");
    currentlySelected = null;
}

// Function to show the selected region's sidebar
function showSelection(regionUID) {
    if (currentlySelected === regionUID) return;
    resetToDefault();

    const hoverEl = document.getElementById("Hover-" + regionUID);
    if (hoverEl) hoverEl.style.display = "block";

    const selectionEl = document.getElementById("selection-" + regionUID);
    if (selectionEl) selectionEl.style.display = "block";

    const regionEl = document.getElementById(regionUID);
    if (regionEl) regionEl.style.display = "none";

    const sidebar = document.querySelector("." + regionUID + "-sidebar");
    const sidebarContainer = document.querySelector(".sidebar");
    if (sidebar && sidebarContainer) {
        sidebarContainer.classList.add("active");
        sidebar.style.display = "block";
    }

    currentlySelected = regionUID;
}

// Function to scale map areas correctly
function scaleMapAreas() {
    const mapImage = document.querySelector(".Full-Interactive-Map");
    if (!mapImage || !mapImage.complete) {
        setTimeout(scaleMapAreas, 500);
        return;
    }

    const baseWidth = mapImage.naturalWidth;
    const baseHeight = mapImage.naturalHeight;
    const displayWidth = mapImage.clientWidth;
    const displayHeight = mapImage.clientHeight;

    document.querySelectorAll(".state-area").forEach(area => {
        const original = area.getAttribute("data-original-coords");
        if (!original) return;

        let coordsArray = original.split(",");
        let scaled = [];

        for (let i = 0; i < coordsArray.length; i += 2) {
            let x = parseFloat(coordsArray[i]);
            let y = parseFloat(coordsArray[i + 1]);
            let newX = Math.round(x * (displayWidth / baseWidth));
            let newY = Math.round(y * (displayHeight / baseHeight));
            scaled.push(newX, newY);
        }

        area.setAttribute("coords", scaled.join(","));
    });
}

// Function to update landmark positions correctly
function updateLandmarkPositions() {
    const map = document.querySelector(".Full-Interactive-Map");
    if (!map) return;

    const mapWidth = map.clientWidth;
    const mapHeight = map.clientHeight;

    document.querySelectorAll(".landmark, .landmark-selection").forEach(landmark => {
        let left = landmark.getAttribute("data-left");
        let top = landmark.getAttribute("data-top");

        if (left && top) {
            landmark.style.left = (parseFloat(left) * mapWidth) + "px";
            landmark.style.top = (parseFloat(top) * mapHeight) + "px";
            landmark.style.position = "absolute";
        }
    });

    document.querySelectorAll(".landmark, .landmark-selection").forEach(el => {
        el.style.visibility = "visible";
    });
}

// Event Listeners for Interactivity
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".landmark, .landmark-selection").forEach(el => {
        if (el) el.style.visibility = "hidden";
    });

    resetToDefault();
    setTimeout(scaleMapAreas, 500);
    setTimeout(updateLandmarkPositions, 500);

    // Auto-select VIC on page load (as per your current setup)
    setTimeout(() => {
        showSelection("VIC");
    }, 700);

    document.querySelectorAll(".state-area").forEach(area => {
        area.addEventListener("click", function (event) {
            event.stopPropagation();
            let regionUID = this.getAttribute("data-region-id");
            showSelection(regionUID);
        });

        area.addEventListener("mouseenter", function () {
            let regionUID = this.getAttribute("data-region-id");
            const hoverEl = document.getElementById("Hover-" + regionUID);
            if (hoverEl) hoverEl.style.display = "block";
        });

        area.addEventListener("mouseleave", function () {
            let regionUID = this.getAttribute("data-region-id");
            if (currentlySelected !== regionUID) {
                const hoverEl = document.getElementById("Hover-" + regionUID);
                if (hoverEl) hoverEl.style.display = "none";
            }
        });
    });

    window.addEventListener("resize", () => {
        setTimeout(scaleMapAreas, 500);
        setTimeout(updateLandmarkPositions, 500);
    });
});
